<div class="orders-invoice mt-3">
  <p-table
    #dtTrackingList
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    [resizableColumns]="true"
    [value]="workflowTrackingList"
    styleClass="p-datatable-customers invoiceListing"
    [rowHover]="true"
    [rows]="4"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    selectionMode="single"
    editMode="row"
    dataKey="trackingNumber"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th *ngIf="showEdit"></th>
        <th class="name text-center">Vendor-SKU</th>
        <th class="number text-center">Quantity</th>
        <th class="name text-center">Tracking Number</th>
        <th class="name text-center">Shipping Method</th>
        <th class="status text-center">Delivery Status</th>
        <th class="name text-center">Action</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-workflowTracking
      let-rowIndex="rowIndex"
      let-editing="editing">
      <ng-container>
        <tr
          class="p-selectable-row"
          [pSelectableRow]="workflowTracking"
          [pEditableRow]="workflowTracking">
          <td *ngIf="showEdit">
            <p-button
              [disabled]="isDisableLink"
              variant="text"
              severity="secondary"
              *ngIf="!editing && workflowTracking.isManualTracking"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"
              (click)="
                editLine(
                  workflowTracking.trackingNumber,
                  workflowTracking.deliveryStatusId
                )
              " />
            <p-button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              variant="text"
              severity="secondary"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(workflowTracking)"
              class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color selectable-color" />
            <p-button
              *ngIf="editing"
              pButton
              pRipple
              variant="text"
              severity="secondary"
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger"
              (click)="refreshGridEvent()" />
          </td>
          <td class="name text-center">
            {{ workflowTracking.vendorSKU }}
          </td>

          <td class="number text-center">
            {{ workflowTracking.quantity }}
          </td>
          <td class="name text-center">
            <a
              class="link"
              *ngIf="showDetailLinks && workflowTracking.isMasterTracking"
              (click)="trackingHistory(workflowTracking)"
              ><strong>{{ workflowTracking.trackingNumber }}</strong></a
            >
            <div *ngIf="!showDetailLinks && workflowTracking.isMasterTracking">
              <strong>{{ workflowTracking.trackingNumber }}</strong>
            </div>
            <a
              class="link pd-lf"
              *ngIf="
                showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                workflowTracking.masterTrackingNumber &&
                workflowTracking.masterTrackingNumber !== ''
              "
              (click)="trackingHistory(workflowTracking)"
              >{{ workflowTracking.trackingNumber }}</a
            >
            <div
              class="pd-lf"
              *ngIf="
                !showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                workflowTracking.masterTrackingNumber &&
                workflowTracking.masterTrackingNumber !== ''
              ">
              {{ workflowTracking.trackingNumber }}
            </div>
            <a
              class="link"
              *ngIf="
                showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                (!workflowTracking.masterTrackingNumber ||
                  workflowTracking.masterTrackingNumber === '')
              "
              (click)="trackingHistory(workflowTracking)"
              >{{ workflowTracking.trackingNumber }}</a
            >
            <div
              *ngIf="
                !showDetailLinks &&
                !workflowTracking.isMasterTracking &&
                (!workflowTracking.masterTrackingNumber ||
                  workflowTracking.masterTrackingNumber === '')
              ">
              {{ workflowTracking.trackingNumber }}
            </div>
          </td>
          <td class="name text-center">
            {{ workflowTracking.shippingMethodName }}
          </td>

          <td class="name text-center">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="workflowTracking.deliveryStatusId"
                  notFoundText="No Status Found"
                  [filter]="true"
                  [showClear]="true"
                  [options]="statusList"
                  optionLabel="name"
                  optionValue="id"
                  appendTo="body">
                </p-select>
              </ng-template>
              <ng-template
                pTemplate="output"
                *ngIf="workflowTracking.isManualTracking">
                {{ getStatus(workflowTracking.deliveryStatusId) }}
              </ng-template>
              <ng-template
                pTemplate="output"
                *ngIf="!workflowTracking.isManualTracking">
                {{ workflowTracking.deliveryStatus }}
              </ng-template>
            </p-cellEditor>
          </td>

          <td
            class="name tracking-detail-cell"
            [ngClass]="
              showDetailLinks ? 'text-end' : 'text-center align-middle'
            ">
            <a
              class="link"
              *ngIf="!workflowTracking.isFromDatabase && !showDetailLinks"
              (click)="deleteRowPageList(workflowTracking)">
              <i class="pi pi-times"></i>
            </a>
            <a
              *ngIf="workflowTracking.isFromDatabase && !showDetailLinks"
              class="link"
              (click)="deleteTrackingRecord(workflowTracking)">
              <i class="pi pi-trash"></i>
            </a>
            <a
              *ngIf="showDetailLinks"
              class="link tracking-detail-link"
              (click)="trackingDetails(workflowTracking)">
              Detail
            </a>
            <p-button
              *ngIf="showDetailLinks"
              [disabled]="isDisableLink"
              icon="pi pi-trash"
              variant="text"
              styleClass="tracking-delete-button"
              (click)="deleteTrackingRecord(workflowTracking)" />
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Trackings found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
